import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/fileAudio.tsx
var FileAudio = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M10 18.223C10 19.6186 8.65685 20.75 7 20.75C5.34315 20.75 4 19.6186 4 18.223C4 16.8274 5.34315 15.6961 7 15.6961C8.65685 15.6961 10 16.8274 10 18.223ZM10 18.223V7.09231C10 6.19957 10.5793 5.41253 11.4253 5.156L17.4253 3.33658C18.7085 2.94746 20 3.91872 20 5.2729V15.1907M20 15.1907C20 16.5863 18.6569 17.7176 17 17.7176C15.3431 17.7176 14 16.5863 14 15.1907C14 13.7951 15.3431 12.6637 17 12.6637C18.6569 12.6637 20 13.7951 20 15.1907Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		d: "M19.1826 3.5356C19.3423 3.48923 19.5012 3.61112 19.5012 3.77995V13.0039C18.8566 12.5823 18.0649 12.3433 17.2512 12.3433C15.314 12.3433 13.5012 13.6981 13.5012 15.6469C13.5012 17.5957 15.314 18.9505 17.2512 18.9505C19.1884 18.9505 21.0012 17.5957 21.0012 15.6469V3.77995C21.0012 2.59815 19.8885 1.7449 18.7706 2.0695L10.2684 4.53826C9.51703 4.75642 8.99902 5.45444 8.99902 6.24871V16.0534C8.35437 15.6318 7.56267 15.3928 6.74902 15.3928C4.8118 15.3928 2.99902 16.7476 2.99902 18.6964C2.99902 20.6452 4.8118 22 6.74902 22C8.68625 22 10.499 20.6452 10.499 18.6964V6.24871C10.499 6.13524 10.573 6.03552 10.6804 6.00436L19.1826 3.5356Z",
		fill: "currentColor"
	})
});
//#endregion
export { FileAudio };
